const downloadBlob = (blob, fileName = 'file-download', isOpen = false) => {
  const a = document.createElement('a')

  document.body.appendChild(a)
  a.style.display = 'none'
  a.addEventListener('click', (e) => {
    e.stopPropagation()
  })

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    a.href = window.URL.createObjectURL(blob)
    a.download = fileName
    a.click()
  }

  document.body.removeChild(a)
}

const getFileNameFromHeader = (headers, contentDisposistionString = null) => {
  if (contentDisposistionString) {
    const match = contentDisposistionString.match(/filename=(.*)/)

    return match && match.length > 1
      ? match[1].replace(/"/g, '')
      : contentDisposistionString
  }

  const contentDisposition = headers['content-disposition']

  if (!contentDisposition) {
    return ''
  }

  const match = contentDisposition.match(/filename=(.*)/)

  return match && match.length > 1
    ? match[1].replace(/"/g, '')
    : contentDisposition
}

export {
  downloadBlob,
  getFileNameFromHeader
}
